"use client";

import React from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Typography } from "./wrappers/Typography";

export interface PrintFilter {
    label: string;
    value: string;
}

interface PrintHeaderProps {
    title?: string;
    titleTx?: string;
    subtitle?: string;
    subtitleTx?: string;
    filters?: PrintFilter[];
}

const PrintHeader: React.FC<PrintHeaderProps> = ({
    title,
    titleTx,
    subtitle,
    subtitleTx,
    filters,
}) => {
    const { t } = useTranslation();
    const resolvedTitle = titleTx ? t(titleTx) : title;
    const resolvedSubtitle = subtitleTx ? t(subtitleTx) : subtitle;
    const visibleFilters = (filters ?? []).filter((f) => f.value);

    return (
        <Box className="print-only app-print-header">
            <Box className="app-print-header-bar">
                {/* eslint-disable-next-line @next/next/no-img-element */}
                <img src="/esiq-logo.png" alt="ESiQ" />
                <Box className="app-print-header-title">
                    {resolvedTitle && (
                        <Typography variant="h6" sx={{ fontWeight: 700, lineHeight: 1.2 }}>
                            {resolvedTitle}
                        </Typography>
                    )}
                    {resolvedSubtitle && (
                        <Typography variant="body2" sx={{ color: "#666" }}>
                            {resolvedSubtitle}
                        </Typography>
                    )}
                </Box>
            </Box>
            {visibleFilters.length > 0 && (
                <Box className="app-print-filters">
                    {visibleFilters.map((f) => (
                        <Box key={f.label} className="app-print-filter-item">
                            <Typography component="span" sx={{ fontWeight: 600 }}>
                                {f.label}:{" "}
                            </Typography>
                            <Typography component="span">{f.value}</Typography>
                        </Box>
                    ))}
                </Box>
            )}
        </Box>
    );
};

export default PrintHeader;
